import { render, staticRenderFns } from "./write-up-history-modal.vue?vue&type=template&id=1969927a&scoped=true"
import script from "./write-up-history-modal.vue?vue&type=script&lang=js"
export * from "./write-up-history-modal.vue?vue&type=script&lang=js"
import style0 from "./write-up-history-modal.vue?vue&type=style&index=0&id=1969927a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1969927a",
  null
  
)

export default component.exports